import { render, staticRenderFns } from "./editCompany.vue?vue&type=template&id=49e79cf8&scoped=true"
import script from "./editCompany.vue?vue&type=script&lang=js"
export * from "./editCompany.vue?vue&type=script&lang=js"
import style0 from "./editCompany.vue?vue&type=style&index=0&id=49e79cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e79cf8",
  null
  
)

export default component.exports